module.exports = __webpack_public_path__ + "static/home-artist-development-7af1f9d1d2c7862522eab2a4dcb9e701.png";